import { useState, useEffect } from "react";
import { ActionCell } from "./GridCells";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-grid.css";

export default function BetterControlledTable({
  columns,
  perPage = 10,
  refreshCounter,
  getTableRows,
  onCellClicked = () => {},
  hasActionButtons = false,
}) {
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  if (hasActionButtons) {
    if (!columns.some((c) => c.headerName === "Actions"))
      columns.unshift({
        headerName: "Actions",
        resizable: true,
        minWidth: 150,
        cellRenderer: (params) => <ActionCell params={params} />,
      });
  }

  useEffect(() => {
    if (gridApi) {
      const dataSource = {
        getRows: async (params) => {
          gridApi.showLoadingOverlay();
          const { rows, total, error } = await getTableRows(
            perPage,
            params.endRow - perPage
          );
          gridApi.hideOverlay();
          if (error) {
            params.successCallback([], 0);
          } else {
            params.successCallback(rows, parseInt(total));
          }
        },
      };
      gridApi.setDatasource(dataSource);
    }
  }, [gridApi, refreshCounter]);
  const rowHeight = 38;

  return (
    <div
      aria-live="polite"
      aria-busy={false}
      className="ag-theme-material"
      //style={{ height: "100%" }}
      style={{
        //height: "500px",
        width: "100%",
      }}
    >
      <AgGridReact
        columnDefs={columns}
        pagination={true}
        rowModelType="infinite"
        paginationPageSize={perPage}
        cacheBlockSize={perPage}
        onGridReady={onGridReady}
        domLayout="autoHeight"
        defaultColDef={{
          resizable: true,
          flex: 1,
        }}
        onCellClicked={onCellClicked}
        headerHeight="38"
        rowHeight={rowHeight}
      />
    </div>
  );
}
